/**
 * Utilidades para el formulario de Axioma
 */

/** Límite de caracteres para descripción correcta (catálogo / jerarquías / revisión) */
export const DESCRIPCION_CORRECTA_MAX_LENGTH = 40

/**
 * Convierte valores booleanos a texto "Sí" o "No"
 */
export const convertirBooleanATexto = (valor) => {
  if (valor === true) return 'Sí'
  if (valor === false) return 'No'
  return valor
}

/**
 * Estados definidos del material
 */
export const ESTADOS_DEFINIDOS = ['ACTIVO', 'INACTIVO', 'OBSOLETO']

/**
 * Opciones para campos de cambio (Sí/No)
 */
export const CAMBIO_OPCIONES = ['No', 'Sí']

/** Campos de medida que deben ser > 0 al finalizar */
export const CAMPOS_MEDIDA_REQUERIDOS = ['largo', 'ancho', 'alto', 'peso']

/**
 * Indica si un campo requerido está vacío.
 * En medidas numéricas, 0 / "0" / negativos también cuentan como faltantes.
 */
export const esCampoRequeridoFaltante = (campo, value) => {
  if (value === null || value === undefined || value === '') return true
  if (Array.isArray(value) && value.length === 0) return true
  if (CAMPOS_MEDIDA_REQUERIDOS.includes(campo)) {
    const n = Number(value)
    return Number.isNaN(n) || n <= 0
  }
  return false
}

/**
 * Regla Ant Design: medida obligatoria y mayor que 0
 */
export const reglaMedidaRequerida = [
  { required: true, message: 'Campo requerido' },
  {
    validator: (_, value) => {
      if (value === null || value === undefined || value === '') {
        return Promise.resolve()
      }
      const n = Number(value)
      if (Number.isNaN(n) || n <= 0) {
        return Promise.reject(new Error('Campo requerido'))
      }
      return Promise.resolve()
    },
  },
]

/**
 * Obtiene los valores iniciales del formulario desde el material
 */
export const getInitialFormValues = (material) => ({
  categoria: material.revision_categoria_sugerida_id,
  descripcionBreve: material.revision_descripcion_breve,
  descripcionCorrecta: material.revision_descripcion_correcta,
  cambioDescripcion: '',
  comentarioAuditor: material.revision_comentario_auditor,
  observacion: material.revision_observacion,
  subcategoria: material.revision_subcategoria_sugerida_id,
  segmento: material.revision_segmento_sugerido_id,
  subsegmento: material.revision_subsegmento_sugerido_id,
  marca: material.revision_marca_sugerida_id,
  estadoDefinido: material.revision_estado_ax,
  usoAplicacion: material.revision_uso_aplicacion,
  largo: material.revision_largo_mm,
  ancho: parseFloat(material.revision_ancho_mm),
  alto: parseFloat(material.revision_alto_mm),
  diametro: parseFloat(material.revision_diametro_mm),
  peso: parseFloat(material.revision_peso_g),
  composicion: material.revision_composicion,
  especificacionesElectricas: material.revision_especificaciones_electricas,
  especificacionesProducto: material.revision_especificaciones_producto,
  tipoEmpaque: material.revision_tipo_empaque_sugerido_id,
  proteccion: material.revision_proteccion_sugerida_id,
  embalaje: material.revision_embalaje_sugerido_id,
  unidadEmpaqueRecomendada: material.revision_unidad_empaque_recomendada,
  cambioEtiqueta: convertirBooleanATexto(material.revision_cambio_etiqueta),
  cambioEmpaque: convertirBooleanATexto(material.revision_cambio_empaque),
})

/**
 * Maneja el cambio de input y convierte a mayúsculas
 */
export const handleUpperCaseChange = (form, fieldName, value, limpiarCampoFaltante) => {
  form.setFieldsValue({
    [fieldName]: value.toUpperCase(),
  })
  limpiarCampoFaltante?.(fieldName)
}

/**
 * Maneja el cambio de select y limpia errores
 */
export const handleSelectChange = (limpiarCampoFaltante, fieldName) => {
  limpiarCampoFaltante?.(fieldName)
}

